import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=2a23a903"
import script from "./nav-bar.vue?vue&type=script&lang=js"
export * from "./nav-bar.vue?vue&type=script&lang=js"
import style0 from "./nav-bar.vue?vue&type=style&index=0&id=2a23a903&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports